import { useState, useEffect } from 'react';
import { updateSortData } from '../redux/actions/sortData.action';
import { useDispatch } from 'react-redux';

/**
 * Хук для управления фильтрами.
 *
 * @param {Object} initialFormData - Начальные данные формы для фильтрации.
 * @param {Object} formData - Текущие данные формы.
 * @param {Function} setFormData - Функция для обновления данных формы.
 * @param {Array} fieldsToIgnoreFalse - Массив полей, для которых `false` является валидным значением.
 * @returns {Object} - Объект с функцией сброса и флагом показа кнопки сброса.
 */
export function useFilterControl(initialFormData, formData, setFormData, fieldsToIgnoreFalse = [], setFilterInput) {
  const [showBtnReset, setShowBtnReset] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const isAnyFieldFilled = Object.entries(formData).some(([key, value]) => {
      // Проверяем, должны ли мы игнорировать `false` как пустое значение для текущего ключа
      if (fieldsToIgnoreFalse.includes(key)) {
        return value !== null && value !== ''; // для указанных полей `false` считается значением
      }
      return value !== null && value !== '' && value !== false; // для всех остальных полей `false` считается пустым
    });

    setShowBtnReset(isAnyFieldFilled);
  }, [formData, fieldsToIgnoreFalse]);

  // Сброс всех фильтров
  const resetFilters = (resetSearch = true) => {
    setFormData(initialFormData);
    dispatch(updateSortData({}));
    setShowBtnReset(false);
    if (resetSearch) {
      setFilterInput('');
    }
  };

  return { resetFilters, showBtnReset };
}
